import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  label?: string;
  labelElement?: React.ReactNode;
  onChange?: React.FormEventHandler<HTMLInputElement>;
}

const Radio: React.FC<Props> = ({
  label,
  labelElement,
  disabled,
  inputRef,
  children,
  className,
  ...restProps
}) => {
  const usedClassName = classNames(
    Classes.RADIO,
    {
      [Classes.RADIO_DISABLED]: disabled,
    },
    className
  );
  return (
    <label className={usedClassName}>
      <input disabled={disabled} type="radio" ref={inputRef} {...restProps} />
      <span className={Classes.RADIO_CONTROL_INDICATOR} />
      {label ?? null}
      {labelElement ?? null}
      {children ?? null}
    </label>
  );
};

export { Radio };
